import { render } from "./modelFindPatient.vue?vue&type=template&id=670eadc5"
import script from "./modelFindPatient.vue?vue&type=script&lang=js"
export * from "./modelFindPatient.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__